<adapt-dialog [maxWidth]="600">
    <h3 adapt-dialog-title>Product usage</h3>
    <div adapt-dialog-content>
        <adapt-display-product-usage [product]="product"></adapt-display-product-usage>
    </div>

    <div adapt-dialog-footer
         class="ms-auto">
        <button #focus
                class="btn btn-default"
                (click)="cancel()">OK</button>
    </div>
</adapt-dialog>
